<template>
  <button id="back-button" :disabled="disabled" :aria-label="ariaLabel" @click.prevent="goBack">
    <label for="back-button" class="iw-visuallyhidden">{{ ariaLabel }}</label>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
      <g fill="none" fill-rule="evenodd">
        <g stroke="currentColor" stroke-width="2">
          <g>
            <path d="M8 0L0 7.5 8 15" transform="translate(-14 -75) translate(16 76)" />
            <path stroke-linecap="square" d="M1.633 7.5L19.367 7.5" transform="translate(-14 -75) translate(16 76)" />
          </g>
        </g>
      </g>
    </svg>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    routeTo: { type: [String, Object] },
    disabled: { type: Boolean, default: false },
    ariaLabel: {
      type: String,
      default: "Go back"
    }
  },
  methods: {
    goBack() {
      if (this.routeTo) {
        this.$router.push(this.routeTo);
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style scoped lang="scss">
#back-button {
  outline: none;
  background-color: initial;
  color: $group-3-color-4;
  border: none;
  cursor: pointer;
  padding: 0;

  &:disabled {
    opacity: 0.5;
  }
}
</style>
